export default {
  dashboardMenu: "منوی کاربری",
  orders: "سفارش‌ها",
  addresses: "آدرس‌ها",
  accountInfo: "اطلاعات حساب کاربری",
  logout: "خروج از حساب کاربری",
    urls: {
    Order:"/fa/dashboard/orders",
    Address:"/fa/dashboard/address",
    Profile:"/fa/dashboard/profile",
  }
};
